<template>
    <div class="web-my-famous-pedia-pop" v-bind:class="{'web-my-famous-pedia-pop-edit': curWebFamousPediaMenu == 4, 'web-my-famous-pedia-pop-cancel': curWebFamousPediaMenu == 5, 'web-my-famous-pedia-pop-down1': curWebFamousPediaMenu == 6, 'web-my-famous-pedia-pop-down2': curWebFamousPediaMenu == 7}">
        <span class="web-my-famous-pedia-triangle " v-bind:class="'triangle-' + curWebFamousPediaMenu"></span>
        <div v-if="curWebFamousPediaMenu != 6" class="web-my-famous-pedia-title-box dsp-flex">
            <div v-if="curWebFamousPediaMenu != 5" class="web-my-famous-pedia-left">
                <span v-if="curWebFamousPediaMenu == 1">我的收藏</span>    
                <span v-if="curWebFamousPediaMenu == 2">我的百科</span>    
                <span v-if="curWebFamousPediaMenu == 3">消息中心</span>    
            </div> 
            <div v-if="curWebFamousPediaMenu != 5" class="web-my-famous-pedia-title">
                <span v-if="curWebFamousPediaMenu == 1 || curWebFamousPediaMenu == 2" class="web-mfpt-year"><span>年</span><span>月</span><span>日</span><span>时</span></span>
                <span v-if="curWebFamousPediaMenu == 3" class="web-mfpt-year"><span @click="clickInformReadAll" v-bind:class="{'gray' : totalUnreadNumber == 0}"><i class="iconfont icon-read"></i>全部已读</span></span>
                <span v-if="curWebFamousPediaMenu == 4" class="web-mfpt-edit">被编辑次数：{{curPediaBaziEditHistoryList.length}}</span>
            </div>
        </div>
        <div class="web-my-famous-pedia-content" v-bind:class="{'web-my-famous-pedia-content-5': curWebFamousPediaMenu == 5}">
            <!-- 默认列表 -->
            <famous-virtual-list
                v-if="curWebFamousPediaMenu == 1 || curWebFamousPediaMenu == 2"
                v-bind:listData="curPediaListData"
                v-bind:gotData="curPediaListGot"
                v-bind:startCollateFunc="clickStartCollate">
            </famous-virtual-list>
            <!-- 2. 通知列表 -->
            <inform-virtual-list
                v-if="curWebFamousPediaMenu == 3"
                v-bind:informList="totalInformList"
                v-bind:informData="totalInformData">
            </inform-virtual-list>
            <!-- 3. 编辑历史列表 -->
            <div v-if="curWebFamousPediaMenu == 4" class="famous-pedia-edit-history-list">
                <famous-edit-history-item
                    v-for="itemData in curPediaBaziEditHistoryList"
                    v-bind:key="itemData.id"
                    v-bind:source="itemData">
                </famous-edit-history-item>
            </div>
            <!-- 4. 退出登录 -->
            <div v-if="curWebFamousPediaMenu == 5" class="famous-crl-item" @click="clickCancel">退出登录</div>
            <!-- 5. 扫码下载弹框 -->
            <div class="famous-code-box dsp-flex" v-show="curWebFamousPediaMenu == 6">
                <div class="famous-code-item">
                    <div class="famous-code-qrcode" ref="qrCodeIOS">
                        <div class="famous-code-icon"><i class="iconfont icon-ios"></i></div>
                    </div>
                    <div class="famous-code-text">ios下载</div>
                </div>
                <div class="famous-code-item">
                    <div class="famous-code-qrcode" ref="qrCodeAND">
                        <div class="famous-code-icon"><i class="iconfont icon-android"></i></div>
                    </div>
                    <div class="famous-code-text">Android下载</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { CONFIG } from '../../modules/config'
import QRCode from 'qrcodejs2'
import FamousVirtualList from '../../layouts/famouspedia/FamousVirtualList.vue'
import InformVirtualList from '../../layouts/inform/InformVirtualList.vue'
import FamousEditHistoryItem from '../../components/famouspedia/FamousEditHistoryItem.vue'
import { COOKIE } from '../../modules/utils'
export default {
    name: 'WebMyFamousPediaPop',
    components: { FamousVirtualList, InformVirtualList, FamousEditHistoryItem },
    computed: {
        curPediaListGot() {
            return this.$store.state.famouspedia.curPediaListGot;
        },
        curPediaListData() {
            return this.$store.state.famouspedia.curPediaListData;
        },
        curWebFamousPediaMenu() {
            return this.$store.state.weblogin.curWebFamousPediaMenu;
        },
        totalUnreadNumber() {
            return this.$store.state.inform.totalUnreadNumber;
        },
        totalInformList() {
            return this.$store.state.inform.totalInformList
        },
        totalInformData() {
            return this.$store.state.inform.totalInformData
        },
        curPediaBaziEditHistoryList() {
            return this.$store.state.famouspedia.curPediaBaziEditHistoryList
        }
    },
    data() {
        return {
            qrCodeValueIOS: '',
            qrCodeValueAND: '',
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initData();
        }, 100);
        this.$bus.on('createQrCode', this.initQrCode);
    },
    destroyed() {
        this.$bus.off('createQrCode', this.initQrCode);
    },
    methods: {
        initData() {
            this.qrCodeValueIOS = CONFIG.ios_durl;
            this.qrCodeValueAND = CONFIG.android_durl;
        },
        initQrCode() {
            var qrcode1 = new QRCode(this.$refs.qrCodeIOS, {
                text: CONFIG.ios_durl,
                width: 100,
                height: 100,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            });
            var qrcode2 = new QRCode(this.$refs.qrCodeAND, {
                text: CONFIG.android_durl,
                width: 100,
                height: 100,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            });
        },
        clickStartCollate() {
            this.$store.state.weblogin.showWebFamousPediaPop = false;
            this.$store.dispatch('collate/initSizhuCollate');
            this.$router.replace('/famouspediacreate')
        },
        clickInformReadAll() {
            if(this.totalUnreadNumber != 0) {
                this.$store.dispatch('inform/setAllMsgRead');
            }
        },
        clickCancel() {
            this.$store.state.weblogin.showWebFamousPediaPop = false;
            this.$store.state.userData = {};
            window.sessionStorage.setItem("H5_Fate_UserInfo", '');
            COOKIE.setCookie('fatetoken', null, 1);

            // 重置一些数据哦
            this.$store.dispatch('record/resetData');
            this.$store.dispatch('famouspedia/resetData');
            this.$store.dispatch('inform/resetData');

            var curUrl = window.location.href;
            if(curUrl.indexOf('famouspediareadweb') == -1) {
                this.$router.replace('/webhome')
            }
        }
    }
}
</script>